import { useBackendSubscription } from './useBackendSubscription';

export interface SubscriptionInfo {
  plan: string;
  status: string;
  isActive: boolean;
  isPro: boolean;
  isPremium: boolean;
  isFree: boolean;
  canAddAssets: boolean;
  maxAssets: number;
  maxStorage: number; // in GB
  maxBanks: number;
  maxViewers: number;
}

export function useSubscription(): SubscriptionInfo {
  const backendSubscription = useBackendSubscription();

  return {
    plan: backendSubscription.plan,
    status: backendSubscription.status,
    isActive: backendSubscription.isActive,
    isPro: backendSubscription.isPro,
    isPremium: backendSubscription.isPremium,
    isFree: backendSubscription.isFree,
    canAddAssets: backendSubscription.canAddAssets,
    maxAssets: backendSubscription.limits.maxAssets,
    maxStorage: backendSubscription.limits.maxStorage,
    maxBanks: backendSubscription.limits.maxBanks,
    maxViewers: backendSubscription.limits.maxViewers,
  };
}

// Helper hook to check if user can perform a specific action
export function useCanPerformAction(action: string): boolean {
  const subscription = useSubscription();

  switch (action) {
    case 'add_asset':
      return subscription.isPro || subscription.isPremium;
    case 'add_bank':
      return subscription.isPro || subscription.isPremium;
    case 'advanced_analytics':
      return subscription.isPremium;
    case 'priority_support':
      return subscription.isPremium;
    case 'google_drive':
      return subscription.isPro || subscription.isPremium;
    default:
      return true;
  }
}
